import React, {forwardRef} from 'react';
import DeleteIcon from "@material-ui/icons/Delete";
import WallpaperIcon from '@material-ui/icons/Wallpaper';
import {OpenWith, PlayCircleFilled} from "@material-ui/icons";
import formatDuration from "../../util/formatDuration";

// A clip cannot be a cover before the worker pulled a poster out of it, and a failed one
// never will be.
function canBePreview(mediaType, status) {
  return mediaType !== 'video' || status === 'ready';
}

function StatusOverlay({status, statusMessage}) {
  if (status === 'pending' || status === 'processing') {
    return (
      <div style={{
        position: 'absolute', inset: 0, zIndex: 3, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '0 8px',
        background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: '13px',
      }}>
        <div>Video wird verarbeitet…</div>
        <div style={{opacity: 0.8, marginTop: '4px'}}>Die Galerie kann schon veröffentlicht werden.</div>
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <div style={{
        position: 'absolute', inset: 0, zIndex: 3, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '0 8px',
        background: 'rgba(150,0,0,0.65)', color: '#fff', fontSize: '13px',
      }}>
        <div>Video fehlgeschlagen</div>
        <div style={{opacity: 0.85, marginTop: '4px', wordBreak: 'break-word'}}>{statusMessage}</div>
      </div>
    );
  }

  return null;
}

export const Photo = forwardRef(({url, index, text, faded, style, isPreview, mediaType = 'image', status = 'ready', statusMessage, duration, ...props}, ref) => {
  const inlineStyles = {
    opacity: faded ? '0.2' : '1',
    transformOrigin: '0 0',
    height: 200,
    position: 'relative',
    background: 'rgba(0,0,0,0.3)',
    ...style,
  };

  const isVideo = mediaType === 'video';
  const previewAllowed = canBePreview(mediaType, status);

  return <div style={inlineStyles}>
    <div ref={ref} style={{width: '100%', height: '100%'}}>
      <div style={{display: "flex", alignItems: 'center', margin: '5px 0 0 5px', minWidth: '100%', color: '#fff', position: 'absolute', zIndex: 4}}>
        <div {...props} style={{cursor: 'move'}} title="Position ändern durch ziehen"><OpenWith /></div>
        <div onClick={() => {props.onDelete(props.id)}} style={{cursor: 'pointer'}} title="Löschen"><DeleteIcon /></div>
        {previewAllowed ? (
          <div onClick={() => {props.onSelectPrimary(props.id)}} style={{cursor: 'pointer'}} title={'Primärbild: '+ (isPreview ? 'Ja' : 'Nein')}><WallpaperIcon style={{color: isPreview ? 'red' : '#fff'}} /></div>
        ) : null}
      </div>
      <div style={{width: '100%', height: '100%', display: "flex", alignItems: 'center', justifyContent: 'center', position: "absolute", top: 0, left: 0, zIndex: 1}}>
        {url ? (<img src={url} alt="" style={{maxWidth: '100%', maxHeight: '100%'}}/>) : null}
        {isVideo && status === 'ready' ? (
          <>
            <PlayCircleFilled style={{position: 'absolute', color: 'rgba(255,255,255,0.85)', fontSize: '48px', pointerEvents: 'none', zIndex: 2}} />
            {duration ? (
              <span style={{position: 'absolute', right: '4px', top: '4px', zIndex: 2, background: 'rgba(0,0,0,0.65)', color: '#fff', fontSize: '12px', padding: '1px 5px', borderRadius: '3px'}}>
                {formatDuration(duration)}
              </span>
            ) : null}
          </>
        ) : null}
        <StatusOverlay status={status} statusMessage={statusMessage} />
        <input type="text" placeholder="Titel vergeben..." value={text} onChange={(e) => {props.onChangeText(props.id, e.target.value)}} style={{background: 'rgba(255,255,255,0.6)', color: '#333', height: '24px', outline: 'none', border: '1px solid #333', position: 'absolute', bottom: 0, width: "100%", left: 0, zIndex: 4, display: props.hideText ? 'none' : 'inline'}} />
      </div>
    </div>
  </div>;
});
